import { dashboardApiHost } from "@/constants/urls";
import axios from "axios";
import { ref } from "vue";

async function getProtectedCampaignGiftBonusPointList(orgId, campaignId, params) {
  const url = `${dashboardApiHost}/orgarea/api/v1/organization/${orgId}/campaign/${campaignId}/campaign-gift-bonus-point`;

  const { data, headers } = await axios.get(url, {
    params,
  });

  return {
    data,
    count: Number(headers["x-total-records"] || (Array.isArray(data) ? data.length : 0)),
  };
}

async function postProtectedAwardCampaignGiftBonusPoint(orgId, campaignId, teamId, payload) {
  const url = `${dashboardApiHost}/orgarea/api/v1/organization/${orgId}/campaign/${campaignId}/team/${teamId}/campaign-gift-bonus-point`;

  const { data } = await axios.post(url, payload);

  return {
    data,
  };
}

async function putProtectedUpdateCampaignGiftBonusPoint(orgId, campaignId, id, payload) {
  const url = `${dashboardApiHost}/orgarea/api/v1/organization/${orgId}/campaign/${campaignId}/campaign-gift-bonus-point/${id}`;

  const { data } = await axios.put(url, payload);

  return {
    data,
  };
}

async function deleteProtectedCampaignGiftBonusPoint(orgId, campaignId, id) {
  const url = `${dashboardApiHost}/orgarea/api/v1/organization/${orgId}/campaign/${campaignId}/campaign-gift-bonus-point/${id}`;

  const { data } = await axios.delete(url);

  return {
    data,
  };
}

export function useCampaignGiftBonusPoint() {
  const orgId = localStorage.getItem("orgId");
  const items = ref([]);
  const loading = ref(false);
  const submitting = ref(false);
  const total = ref(0);

  async function fetchOrgCampaignGiftBonusPointList(campaignId, params) {
    loading.value = true;

    try {
      const { data, count } = await getProtectedCampaignGiftBonusPointList(
        orgId,
        campaignId,
        params
      );
      items.value = Array.isArray(data) ? data : [];
      total.value = count;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function awardOrgCampaignGiftBonusPoint(campaignId, teamId, payload) {
    submitting.value = true;

    try {
      const { data } = await postProtectedAwardCampaignGiftBonusPoint(
        orgId,
        campaignId,
        teamId,
        payload
      );
      return data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      submitting.value = false;
    }
  }

  async function updateOrgCampaignGiftBonusPoint(campaignId, id, payload) {
    submitting.value = true;

    try {
      const { data } = await putProtectedUpdateCampaignGiftBonusPoint(
        orgId,
        campaignId,
        id,
        payload
      );
      return data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      submitting.value = false;
    }
  }

  async function deleteOrgCampaignGiftBonusPoint(campaignId, id) {
    submitting.value = true;

    try {
      const { data } = await deleteProtectedCampaignGiftBonusPoint(orgId, campaignId, id);
      return data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      submitting.value = false;
    }
  }

  return {
    items,
    total,
    loading,
    submitting,
    fetchOrgCampaignGiftBonusPointList,
    awardOrgCampaignGiftBonusPoint,
    updateOrgCampaignGiftBonusPoint,
    deleteOrgCampaignGiftBonusPoint,
  };
}
